export default {
      id: "login-yandex_oauth2-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "sprite-46b249.svg#login-yandex_oauth2-usage",
      toString: function () {
        return this.url;
      }
    }